"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGrupo = void 0;
var radioModule = require('./RadioGrupo.module.scss');
var react_1 = __importDefault(require("react"));
var RadioGrupo = function (_a) {
    var id = _a.id, classes = _a.classes, children = _a.children, _b = _a.orientacao, orientacao = _b === void 0 ? "HORIZONTAL" : _b;
    var classeOrientacao = "";
    if (orientacao)
        classeOrientacao = orientacao === "HORIZONTAL" ? radioModule.orientacaoHorizontal : radioModule.orientacaoVertical;
    return (react_1.default.createElement("div", { className: "".concat(radioModule.radioGrupo, " ").concat(classes, " ").concat(classeOrientacao) }, children));
};
exports.RadioGrupo = RadioGrupo;
